
// export default ResetPassword;
import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import logo from './assets/logo-footer.png'; // Update path as needed
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useLanguage } from './store/language-context';
import { useTranslation } from 'react-i18next';

const ResetPassword = () => {
  const { URL } = useLanguage();
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { contact, contact_type } = location.state || {};



  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    if (password.length < 6) {
      setError(t('register.pass-length'));
      setLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setError(t('register.pass-err'));
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${URL}/reset-password`, {
        contact: contact,
        contact_type: contact_type,
        password,
        password_confirmation: confirmPassword,
      });

      if (response.status === 200) {
        setSuccess(t('register.done-pass'));
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setError(t('custom.err'));
      }
    } catch (error) {
      setError(t('custom.err'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-section">
      <div className="login row justify-content-between">
        <div className="right-section logoimg col-lg-7 col-md-6">
          <Link to="/" className="image-part">
            <img src={logo} className="img-fluid w-100" alt="Logo" />
          </Link>
        </div>
        <div className="form-part col-lg-5 col-md-6 mt-4">
          <div className="container">
            {/* Left Side: Form */}
            <div>
              <div className="rest">
                <p>{t('hello')}</p>
                <h6>{t('routes.reset-password')}</h6>

                <form onSubmit={handleSubmit} className="space-y-4">
                  {/* Password Field */}
                  <div className="relative">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      placeholder={t('contact.new-pass')}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="w-full px-4 py-2  rounded-md focus:outline-none "
                    />
                    <button
                      type="button"
                      className="absolute right-3 top-3 text-gray-600"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                  </div>

                  {/* Confirm Password Field */}
                  <div className="relative">
                    <input
                      type={showConfirmPassword ? 'text' : 'password'}
                      placeholder={t('register.submit-pass')}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className="w-full px-4 py-2  rounded-md focus:outline-none "
                    />
                    <button
                      type="button"
                      className="absolute right-3 top-3 text-gray-600"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                      {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-[#661B21] text-white py-2 rounded-md hover:bg-[#500F14] transition"
                  >
                    {loading ? t('custom.sending') : t('custom.send')}
                  </button>

                  {error && <p className="text-red-600 text-sm text-center">{error}</p>}
                  {success && <p className="text-green-600 text-sm text-center">{success}</p>}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
